import { createTenant } from "../../api";
import {
  Title,
  TextInput,
  Button,
  Container,
  Stack,
  Alert,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useState } from "react";
import { useLocation } from "wouter";

export default function TenantCreate() {
  const [, setLocation] = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm({
    initialValues: {
      tenantName: "",
      // tenantSlug: "",
      emailAddress: "",
    },
    validate: {
      emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
      // tenantSlug: (val) => (/^[a-z][a-z0-9_-]+$/.test(val) ? null : "Invalid slug"),
    },
  });

  return (
    <Container size="sm">
      <Title order={1}>Create new tenant</Title>

      <form
        onSubmit={form.onSubmit((values) => {
          setIsLoading(true);
          createTenant(values)
            .then(() => {
              setLocation("/tenants");
            })
            .finally(() => {
              setIsLoading(false);
            });
        })}
      >
        <Stack>
          <Alert mt="md">
            This will send an invitation email to the tenant owner with a link
            to set a password
          </Alert>
          <TextInput
            label="Tenant company name"
            placeholder="XYZ Company SAS"
            value={form.values.tenantName}
            onChange={(event) =>
              form.setFieldValue("tenantName", event.currentTarget.value)
            }
            error={form.errors.tenantName}
            radius="md"
          />
          <TextInput
            label="Tenant owner email"
            placeholder="benoit@xyz-sas.example.com"
            value={form.values.emailAddress}
            onChange={(event) =>
              form.setFieldValue("emailAddress", event.currentTarget.value)
            }
            error={form.errors.emailAddress}
            radius="md"
          />
          <Button loading={isLoading} mt="lg" type="submit">
            Create
          </Button>
        </Stack>
      </form>
    </Container>
  );
}
